/* PILSNERISH OS — pz-marquee: seamless ticker. Base speed in px/s; scroll velocity boosts the speed and
 * flips the direction (scroll up = reverse), then eases back to base. Pauses off-screen.
 * R8 CPU: the track moves with ONE Web Animations transform animation (compositor-driven, no per-frame JS). Scroll only
 * changes its playbackRate; the ease back to base runs a short rAF decay that stops once the boost is gone. No
 * ScrollTrigger: scroll velocity comes from passive scroll events.
 * R15: runs under prefers-reduced-motion too (Android battery saver reports reduce and froze it); idle still pauses it. */
(function () {
  'use strict';
  var w = window, d = document;
  if (w.__pzMarquee) return;
  w.__pzMarquee = true;
  var PZ = w.PZ;
  if (!PZ || !PZ.onSection) return;

  PZ.onSection('marquee', function (el) {
    var track = el.querySelector('[data-track]');
    var group = track && track.querySelector('[data-group]');
    if (!group) return;
    var base = parseFloat(el.getAttribute('data-speed')) || 110;
    var dir0 = el.getAttribute('data-dir') === 'right' ? 1 : -1;
    var react = el.getAttribute('data-react') !== 'false';
    var clones = [], gw = 0, dir = dir0, boost = 0, running = false, dead = false, decayRaf = 0, lastT = 0;
    var anim = null, stopIO = null, ro = null, lastY = w.scrollY, lastScrollT = 0;
    var canAnimate = typeof track.animate === 'function';

    function rate() { return (1 + boost) * (dir === dir0 ? 1 : -1); }
    function build() {
      gw = group.getBoundingClientRect().width;
      if (!gw) return;
      var need = Math.max(1, Math.ceil(el.clientWidth / gw) + 1);
      while (clones.length < need) {
        var c = group.cloneNode(true);
        c.removeAttribute('data-group');
        c.querySelectorAll('[data-shopify-editor-block]').forEach(function (n) { n.removeAttribute('data-shopify-editor-block'); });
        track.appendChild(c);
        clones.push(c);
      }
      while (clones.length > need) track.removeChild(clones.pop());
      if (!canAnimate) return;
      /* one loop = one group width at the base speed; left-moving = 0 -> -gw, right-moving = -gw -> 0 */
      var from = dir0 < 0 ? 0 : -gw, to = dir0 < 0 ? -gw : 0;
      var dur = gw / base * 1000;
      var prog = anim && anim.effect ? ((anim.currentTime || 0) % dur) / dur : 0;
      if (anim) anim.cancel();
      anim = track.animate([{ transform: 'translate3d(' + from + 'px,0,0)' }, { transform: 'translate3d(' + to + 'px,0,0)' }], { duration: dur, iterations: Infinity, easing: 'linear' });
      /* start far into the iteration count so a negative playbackRate (scroll up) can run backwards for hours */
      anim.currentTime = dur * (100000 + prog);
      anim.playbackRate = rate();
      if (!running) anim.pause();
    }

    function decay(now) {
      decayRaf = 0;
      if (dead || !anim) return;
      var dt = Math.min(0.05, (now - lastT) / 1000);
      lastT = now;
      boost *= Math.pow(0.04, dt); // ~ -96%/s decay back to base
      if (boost < 0.02) boost = 0;
      anim.playbackRate = rate();
      if (boost > 0 && running) decayRaf = requestAnimationFrame(decay);
    }
    function nudge(vel) {
      // vel: px/s of page scroll; positive = scrolling down
      if (!react || !vel || !anim) return;
      dir = vel > 0 ? dir0 : -dir0;
      boost = Math.max(boost, Math.min(6, Math.abs(vel) / 350));
      anim.playbackRate = rate();
      if (!decayRaf) { lastT = performance.now(); decayRaf = requestAnimationFrame(decay); }
    }
    var inView = false;
    function setRunning(on) {
      inView = on;
      if (PZ.idle) on = false;
      running = on;
      el.classList.toggle('is-paused', !on);
      if (!anim) return;
      if (on) anim.play(); else { anim.pause(); if (decayRaf) { cancelAnimationFrame(decayRaf); decayRaf = 0; } }
    }
    /* R8 CPU: hold still while the page is idle (45 s without input) */
    function onIdle() { setRunning(inView); }
    d.addEventListener('pz:idle', onIdle);
    function onScroll() {
      var now = performance.now(), y = w.scrollY, dy = y - lastY, dt = (now - lastScrollT) / 1000;
      lastY = y; lastScrollT = now;
      if (running && dy && dt > 0 && dt < 0.25) nudge(dy / dt);
    }
    w.addEventListener('scroll', onScroll, { passive: true });

    build();
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { if (!dead) build(); });
    if ('ResizeObserver' in w) { ro = new ResizeObserver(function () { build(); }); ro.observe(group); ro.observe(el); }
    else w.addEventListener('resize', build);
    stopIO = PZ.inView(el, setRunning, { media: false, rootMargin: '100px 0px' });

    return function () {
      dead = true;
      setRunning(false);
      if (anim) anim.cancel();
      if (stopIO) stopIO();
      w.removeEventListener('scroll', onScroll);
      d.removeEventListener('pz:idle', onIdle);
      if (ro) ro.disconnect(); else w.removeEventListener('resize', build);
      clones.forEach(function (c) { c.remove(); });
    };
  });
})();
